import Swiper from 'swiper';

export function initSwiper(container) {
    const swiperMap = new WeakMap();
    document.querySelectorAll(container).forEach((el, idx) => {
      const elDiv = el; // jawnie traktuj jako HTMLElement
      const navIdx = idx + 1;
      const swiper = new Swiper(elDiv, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 500,
        loop: true,
        navigation: {
          nextEl: `.swiper-nav-next-${navIdx}`,
          prevEl: `.swiper-nav-prev-${navIdx}`,
        },
      });
      swiperMap.set(elDiv, swiper);
    });
  
    document.querySelectorAll('.menu-button-prev, .menu-button-next').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        e.preventDefault(); // Blokuje domyślną akcję <a>
        const swiperContainer = this.closest(container);
        const swiper = swiperMap.get(swiperContainer);
        if (swiper) {
          if (this.classList.contains('menu-button-prev')) {
            swiper.slidePrev();
          } else {
            swiper.slideNext();
          }
        }
      });
    });
  
}
